function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .action-opps-do-something_svg__action-opps-do-something_svg__st0{fill:#010101}.action-opps-do-something_svg__action-opps-do-something_svg__st1{fill:#FFFFFF}.action-opps-do-something_svg__action-opps-do-something_svg__st2{fill:#231F20}\n  ");

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st0",
  points: "616 285.3 599.1 13.1 430.6 33.7 237.5 46.4 18.8 59.1 36 175.1 51.9 349 56.7 533.7 307.9 513.9 531.3 499 642.3 498"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  d: "m164.1 400.3c-1.7-13-9-19.2-20.8-27.6-9.7-6.8-17.3-11.7-18.4-20.2-0.7-5.3 2.4-9.1 7.2-9.7 5.6-0.7 8.7 2.5 10.4 10.5l14.1-3.9c-3.1-14.5-13.3-21.9-25.9-20.3-12.9 1.7-22.1 13.1-20.3 26.6 1.6 12.4 10.2 19.1 22.7 28.1 9.1 6.6 15.6 10.7 16.6 18.5 0.7 5.5-2.8 9.6-8.4 10.3-6.4 0.8-10.5-3.2-12.3-12.6l-13.8 4c2.9 16.4 13.8 24.6 28.6 22.6 13.6-1.6 22.1-12.5 20.3-26.3z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  d: "m295.2 404.7-12.4-93.9-20.1 2.7-2.6 53.4c-0.2 4.6 0 11 0.7 15.8-0.7-5-1.9-11.4-3.3-15.5l-16.8-50.7-19.8 2.6 12.4 93.9 13.7-1.8-5.5-41.4-2.6-17.9c-0.5-3.9-1.3-9.3-2.9-16.2 0.4 1.2 2 5.5 4.4 12.9l19.9 60.8 7.5-1 4-64c0.2-2.6 0.6-7.1 0.9-13.6 0.3 8.4 0.9 13.8 1.3 16.5l2.1 17.6 5.5 41.7 13.6-1.9z"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  points: "342.3 398.3 340.4 384.2 321.2 386.8 318 363.2 337.2 360.5 335.4 347.3 316.3 350.1 312.5 320.4 335.1 317.2 333.3 303.8 295.9 309 308.3 402.9"
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  points: "361.2 335.9 377.1 334 375.3 320.9 325.7 327.3 327.5 340.4 346.4 337.9 357 418.7 371.8 416.7"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  points: "394.8 413.8 409.5 411.8 403.9 369.8 419.1 367.8 424.7 409.8 439.5 407.9 427.1 313.9 412.3 315.9 417.3 354.2 402.1 356.2 397.1 317.9 382.4 319.9"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  points: "413.5 468.5 411.9 455.8 399 457.4 400.6 470.1"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  transform: "matrix(.9914 -.131 .131 .9914 -43 62.511)",
  x: 446.1,
  y: 310.8,
  width: 15.2,
  height: 94.7
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  d: "m468.2 308.5 12.4 93.9 13.7-1.8-4.9-37.4-1.8-11.7c-0.3-2-1.2-6.3-3.2-12.8 1.7 4.4 3.4 7.5 4.6 9.8l25.5 49.4 13.8-1.8-12.4-93.9-13.8 1.8 5.9 44.7 1.4 8.7c0.2 1.6 1 6 3.1 12.5-2.3-5.7-3.9-8.8-4.3-9.6l-26.7-53.6-13.3 1.8z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  d: "m567 443.6-2.5-20.6-21 2.6 1.1 9.3 9-1.1 0.7 5.5c-1.7 1.5-4 2.4-7.1 2.8-7.2 0.9-13.1-3.8-14-11.1v-0.1c-0.9-7 3.5-13.2 10.1-14 4.5-0.6 8 0.6 11.6 2.9l6.3-9.8c-5.3-3.6-11.3-5.4-19.4-4.4-14.2 1.8-23.3 13.5-21.7 26.8v0.1c1.7 13.8 13.6 22.3 27.8 20.6 8.4-1 14.8-4.9 19.1-9.5z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  d: "m585.4 388.5-6.3-47.3-23.7 3.1 1.6 12 9.5-1.2 1.9 14.6c0.8 6.5-1.6 10.2-6.8 10.9s-8.5-2.3-9.4-8.8l-6.9-52.4c-0.9-6.5 1.6-10.1 6.8-10.8s8.5 2.1 9.3 8.6l1.3 10 14.2-1.9-1.1-8.7c-2.1-16-10.6-23.1-24.9-21.2-15.1 2-22.5 12.2-20.6 26.8l6.3 48.1c2.3 17 10.7 25.1 24.2 23.3 6.7-0.9 11-4.1 13.6-10.4l3.8 6.1 7.2-0.8z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  d: "m218.4 390.7-6.4-48.2c-2-15.2-12.1-22.9-25.9-21.1-15.1 2-22.5 12.2-20.6 26.8l6.4 48.2c2.3 17.2 11.5 25 26.6 23 14.9-1.9 22.1-12.1 19.9-28.7zm-21.7 14.7c-5.2 0.7-8.5-2.3-9.3-8.8l-6.9-52.4c-0.9-6.5 1.6-10.1 6.7-10.8 5.2-0.7 8.5 2.1 9.3 8.6l6.9 52.4c0.9 6.6-1.6 10.3-6.7 11z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  d: "m465.2 439.1v-0.1c-1.6-13.1-13.4-22.4-27.5-20.6s-23.3 13.7-21.7 26.8v0.1c1.6 13.1 13.4 22.3 27.4 20.6 14.2-1.8 23.4-13.7 21.8-26.8zm-22.5 15.1c-6.9 0.9-12.4-4.3-13.2-10.9v-0.1c-0.8-6.6 3.1-12.8 10-13.6 7-0.9 12.5 4.3 13.3 10.9v0.1c0.8 6.5-3.1 12.7-10.1 13.6z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  d: "m504.8 441.3c5.4-3.1 8.5-8.2 7.7-15.2v-0.1c-0.6-4.5-2.4-7.9-5.4-10.1-3.5-2.8-8.5-4-15.5-3.1l-21.6 2.7 5.6 45.7 12.7-1.6-1.7-13.8 5.4-0.7h0.1l10.9 12.7 14.6-1.8-12.8-14.7zm-10.7-7.9-8.3 1-1.4-11 8.3-1c4.2-0.5 7.1 1 7.5 4.6v0.1c0.4 3.4-1.8 5.8-6.1 6.3z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  d: "m316 188.4c-1.6-18.5-6.7-34.9-15.2-49.4s-19.2-25.8-31.9-33.8-25.8-12.7-39.1-14.2-30.7-1.3-52.1 0.6l-101.9 8.9 3.2 36.3 32.6-2.9 12.4 142.5-32.6 2.9 3.2 36.3 108.5-9.5c18.2-1.6 31.6-3.5 40.2-5.7s17.9-6.2 27.8-12c10-5.8 18.3-13.2 25.1-22.1 6.8-9 12.1-20.4 15.9-34.4 3.9-14.1 5.2-28.5 3.9-43.5zm-63.6 47.9c-4.9 11.2-11.8 19.3-21 24.4s-21.9 8.3-38.1 9.7l-13.5 1.2-12.5-142.4 13.5-1.2c15.3-1.3 28.2-0.3 38.5 3.2s18.9 10.6 25.7 21.6c6.8 10.9 11 24.6 12.4 41 1.5 17.1-0.1 31.3-5 42.5z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st1",
  d: "m563.5 171.7c-3.5-29.8-17.1-55.6-40.6-74-22.8-17.9-53.1-26-90.6-21.6-37.6 4.4-65.2 19.4-83.2 42.2-18.4 23.3-25.7 51.5-22.2 81.2 3.4 28.8 16.6 54.4 39.6 73.2 22.4 18.4 53 26.9 91.5 22.4 37.5-4.4 65-19.3 83-41.9 18.7-23.6 25.9-52 22.5-81.5zm-70.8 61.3c-9.9 13.6-23.7 21.4-39.4 23.2-16.9 2-31.8-2.9-44-13.9-12.4-11.2-20.3-27.6-22.7-48.5-2.8-24.1 1.4-42.5 10.9-55.7 9.9-13.8 23.8-21.4 39.3-23.2 17.2-2 32.5 3 44.8 14.5 12 11.3 19.8 27.6 22.2 48.7 2.8 23.3-1.5 41.6-11.1 54.9z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-do-something_svg__action-opps-do-something_svg__st2",
  d: "m681 477.6c0 8.3-6.7 14.9-15.1 14.9-8.5 0-15.2-6.6-15.2-14.9s6.8-14.8 15.3-14.8c8.4 0 15 6.5 15 14.8zm-26.6 0c0 6.6 5 11.8 11.5 11.8 6.4 0.1 11.3-5.2 11.3-11.7 0-6.6-4.9-11.9-11.4-11.9-6.4 0-11.4 5.3-11.4 11.8zm9.1 7.6h-3.4v-14.8c1.4-0.2 3.2-0.5 5.7-0.5 2.8 0 4.1 0.5 5 1.2 0.9 0.6 1.5 1.7 1.5 3.2 0 1.8-1.4 3-3.1 3.5v0.2c1.4 0.5 2.2 1.6 2.6 3.6 0.5 2.3 0.8 3.1 1.1 3.6h-3.6c-0.5-0.5-0.7-1.8-1.2-3.6-0.3-1.5-1.2-2.3-3.1-2.3h-1.6v5.9zm0.1-8.3h1.6c1.9 0 3.4-0.6 3.4-2.2 0-1.4-1-2.3-3.2-2.3-0.9 0-1.5 0.1-1.9 0.2v4.3z"
});

function SvgActionOppsDoSomething(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 691.8 549.5",
    viewBox: "0 0 691.8 549.5",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

export default SvgActionOppsDoSomething;